module.exports = __webpack_public_path__ + "static/img/active4.8f81d24e.png";